import { render, staticRenderFns } from "./cta-banner-both.vue?vue&type=template&id=00b13d73&scoped=true"
import script from "./cta-banner-both.vue?vue&type=script&lang=js"
export * from "./cta-banner-both.vue?vue&type=script&lang=js"
import style0 from "./cta-banner-both.vue?vue&type=style&index=0&id=00b13d73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b13d73",
  null
  
)

export default component.exports